module.exports = __webpack_public_path__ + "static/assets/5c3d84a742d810a901f40a4b3640fd82.png";